import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@tom-ui/planning'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import _ from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { PieItem } from '../components/PieGraph'
import { VisitCard } from '../components/VisitCard'
import {
  getContainerSummaryFromVisits,
  getDefaultVisitStatusForPieChart,
  isDateBetweenFromAndTo,
  updateVisitDashabordsByStatus,
} from '../helpers/helper'

interface Props {
  currentDate: Date
}
export const RailVisitWidget = observer(({ currentDate }: Props) => {
  const { t } = useTranslate()
  const { railVisitItemStore } = usePlanningStore()
  const theme = useMinimalsTheme()

  const getVisits = () => {
    return _(railVisitItemStore.elements)
      .filter(
        visit =>
          visit.data.status === 'InOperation' ||
          isDateBetweenFromAndTo(currentDate, visit.arrival, visit.departure),
      )
      .value()
  }

  const graphItems = computed(() => {
    const items: PieItem[] = getDefaultVisitStatusForPieChart(theme, t)

    getVisits().forEach(visit => {
      updateVisitDashabordsByStatus(items, visit.data.status)
    })

    return items.filter(x => x.value > 0)
  }).get()

  const containersSummary = computed(() => {
    return getContainerSummaryFromVisits(getVisits())
  }).get()

  return (
    <VisitCard
      title={t('trains', 'Trains')}
      seeMorePath={PATHS.visits.railVisits.url}
      graphItems={graphItems}
      containersIn={containersSummary.summaryIn}
      containersOut={containersSummary.summaryOut}
      dataCy='train-widget-card'
    />
  )
})
